import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuestionsComponent } from 'src/app/components/questions/questions.component';
import { ThankyouComponent } from 'src/app/components/thankyou/thankyou.component';

const routes: Routes = [
  {
    path: '',
    component: QuestionsComponent},
    {
      path: 'thankyou',
      component: ThankyouComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
